import { getImageUrl } from './config/s3Config';

export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Interactive Online Learning",
    desc: "Experience immersive online courses with interactive content, real-time discussions, and hands-on projects designed to enhance your learning journey.",
  },
  {
    id: 2,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Industry-Recognized Certificates",
    desc: "Earn valuable certificates that are recognized by leading employers and institutions worldwide, boosting your career prospects and professional credibility.",
  },
  {
    id: 3,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Learn from Industry Experts",
    desc: "Get guidance from seasoned professionals and industry leaders who bring real-world experience and cutting-edge knowledge to every lesson.",
  },
]
export const homeAbout1 = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Interactive Online Learning",
    desc: "Experience immersive online courses with interactive content, real-time discussions, and hands-on projects designed to enhance your learning journey.",
  },
  {
    id: 2,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Industry-Recognized Certificates",
    desc: "Earn valuable certificates that are recognized by leading employers and institutions worldwide, boosting your career prospects and professional credibility.",
  },
  {
    id: 3,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Learn from Industry Experts",
    desc: "Get guidance from seasoned professionals and industry leaders who bring real-world experience and cutting-edge knowledge to every lesson.",
  },
  {
    id: 4,
    cover: "https://img.icons8.com/ios/80/000000/graduation-cap--v1.png",
    title: "Flexible Learning Schedule",
    desc: "Study anytime, anywhere, at your own pace, making it easy to balance education with work, family, and other commitments.",
  },
  {
    id: 5,
    cover: "https://img.icons8.com/ios/80/000000/idea.png",
    title: "Practical Skill Development",
    desc: "Gain hands-on skills and knowledge that you can apply immediately in your career or business projects.",
  },
  {
    id: 6,
    cover: "https://img.icons8.com/ios/80/000000/network.png",
    title: "Global Student Community",
    desc: "Connect with a diverse network of learners, share experiences, collaborate on projects, and expand your professional connections.",
  },
  {
    id: 7,
    cover: "https://img.icons8.com/ios/80/000000/online-support.png",
    title: "24/7 Student Support",
    desc: "Access dedicated support services to assist with technical issues, course queries, and career guidance, anytime you need help.",
  }
];

export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "8,500+",
    title: "SUCCESSFUL GRADUATES",
    description: "Students who've transformed their careers"
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "650+",
    title: "EXPERT INSTRUCTORS",
    description: "Industry professionals and academic leaders"
  },
  {
    cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "12,800+",
    title: "ACTIVE LEARNERS",
    description: "Students currently enrolled and learning"
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "1,250+",
    title: "COURSES AVAILABLE",
    description: "Comprehensive programs across multiple disciplines"
  },
]

export const coursesCard = [
  {
    id: 1,
    cover: getImageUrl("../images/courses/c1.png"),
    coursesName: "Introducing to Software Engineering",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by John Smith",
        totalTime: "50 lectures (190 hrs)",
      },
    ],
    priceAll: "$100 All Course",
    pricePer: "$15 per month",
  },
  {
    id: 2,
    cover: getImageUrl("../images/courses/c2.png"),
    coursesName: "Enhancing Adobe Photoshop CC 2020 Skills",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Ram Gurung",
        totalTime: "30 lectures (125 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
  {
    id: 3,
    cover: getImageUrl("../images/courses/c3.png"),
    coursesName: "HTML, CSS, and Javascript for Web Developers",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Saroj Nepal",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$50 All Course",
    pricePer: "$5 per month",
  },
  {
    id: 4,
    cover: getImageUrl("../images/courses/c4.png"),
    coursesName: "Introducing to Programming with WordPress",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Prabin Thapa Mager",
        totalTime: "20 lectures (20 hrs)",
      },
    ],
    priceAll: "$30 All Course",
    pricePer: "$3 per month",
  },
  {
    id: 5,
    cover: getImageUrl("../images/courses/c5.png"),
    coursesName: "Introducing to Programming with ReactJS",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Sunil Bishowkaram",
        totalTime: "100 lectures (150 hrs)",
      },
    ],
    priceAll: "$300 All Course",
    pricePer: "$30 per month",
  },
  {
    id: 6,
    cover: getImageUrl("../images/courses/c6.png"),
    coursesName: "Learn Frontend Programming Language",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Sunil Bishowkaram",
        totalTime: "200 lectures (300 hrs)",
      },
    ],
    priceAll: "$500 All Course",
    pricePer: "$80 per month",
  },
  {
    id: 7,
    cover: getImageUrl("../images/courses/c7.png"),
    coursesName: "Introducing to with HTML / CSS",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Price",
        totalTime: "20 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$2 per month",
  },
  {
    id: 8,
    cover: getImageUrl("../images/courses/c8.png"),
    coursesName: "Introducing to with JAVA",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Petter",
        totalTime: "80 lectures (200 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$40 per month",
  },
  {
    id: 9,
    cover: getImageUrl("../images/courses/c9.png"),
    coursesName: "Introducing to with HTML / CSS / JAVASCRIPT",
    courTeacher: [
      {
        dcover: getImageUrl("./images/back.webp"),
        name: "by Petter",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$3 per month",
  },
]
export const online = [
  {
    cover: getImageUrl("./images/courses/online/o1.png"),
    hoverCover: getImageUrl("./images/courses/online/o1.1.png"),
    courseName: "UI/UX Design Courses",
    course: "25 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o2.png"),
    hoverCover: getImageUrl("./images/courses/online/o2.1.png"),
    courseName: "Art & Design",
    course: "25 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o3.png"),
    hoverCover: getImageUrl("./images/courses/online/o3.1.png"),
    courseName: "Computer Science",
    course: "10 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o4.png"),
    hoverCover: getImageUrl("./images/courses/online/o4.1.png"),
    courseName: "History & Archeologic",
    course: "15 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o5.png"),
    hoverCover: getImageUrl("./images/courses/online/o5.1.png"),
    courseName: "Software Engineering",
    course: "30 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o6.png"),
    hoverCover: getImageUrl("./images/courses/online/o6.1.png"),
    courseName: "Information Software",
    course: "60 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o7.png"),
    hoverCover: getImageUrl("./images/courses/online/o7.1.png"),
    courseName: "Health & Fitness",
    course: "10 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o8.png"),
    hoverCover: getImageUrl("./images/courses/online/o8.1.png"),
    courseName: "Marketing",
    course: "30 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o9.png"),
    hoverCover: getImageUrl("./images/courses/online/o9.1.png"),
    courseName: "Graphic Design",
    course: "80 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o10.png"),
    hoverCover: getImageUrl("./images/courses/online/o10.1.png"),
    courseName: "Music",
    course: "120 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o11.png"),
    hoverCover: getImageUrl("./images/courses/online/o11.1.png"),
    courseName: "Business Administration",
    course: "17 Courses",
  },
  {
    cover: getImageUrl("./images/courses/online/o12.png"),
    hoverCover: getImageUrl("./images/courses/online/o12.1.png"),
    courseName: "Web Management",
    course: "17 Courses",
  },
]
export const team = [
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Snr. Prof. Krishanthi Abeywickrama",
    work: "Senior Professor, Department of Botany, Faculty of Science, University of Kelaniya",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Prof. Piyal Ekanayake",
    work: "Professor, Department of Mathematical Sciences, Faculty of Applied Sciences, Wayamba University of Sri Lanka",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Prof. Sujeewa Kodithuwakku",
    work: "Professor, Department of Business Finance, Faculty of Management, University of Peradeniya",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Prof. Manori Weeratunga",
    work: "Professor, Department of Demography, Faculty of Arts, University of Colombo",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Dr. Indika Lakmal",
    work: "Senior Lecturer, Department of Banking and Finance, Faculty of Business Studies and Finance, Wayamba University of Sri Lanka",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Dr. Emil Kumara",
    work: "Senior Lecturer, Department of Accountancy, Faculty of Business Studies and Finance, Wayamba University of Sri Lanka",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Dr. Buddhika Abeyrathna",
    work: "Lecturer, Department of Psychiatry, Faculty of Medicine and Allied Sciences, Rajarata University of Sri Lanka",
  },
  {
    cover: getImageUrl("./images/team/t001.jpg"),
    name: "Dr. Mohan Samaranayaka",
    work: "Senior Lecturer, Department of English Language Teaching, Faculty of Business Studies and Finance, Wayamba University of Sri Lanka",
  }
]
export const price = [
  {
    name: "STARTER PLAN",
    price: "29K",
    period: "per month",
    desc: "Perfect for beginners starting their learning journey",
    features: [
      "Access to 50+ basic courses",
      "Certificate upon completion",
      "Basic study materials",
      "Email support",
      "Mobile app access",
      "Progress tracking"
    ],
    popular: false,
    color: "#6366f1"
  },
  {
    name: "STANDARD PLAN",
    price: "59K",
    period: "per month",
    desc: "Ideal for serious learners seeking comprehensive education",
    features: [
      "Access to 200+ premium courses",
      "Professional certification",
      "Advanced study materials",
      "Priority email support",
      "Mobile app access",
      "Progress tracking",
      "Study groups access",
      "Monthly webinars"
    ],
    popular: true,
    color: "#1976d2"
  },
  {
    name: "PREMIUM PLAN",
    price: "99K",
    period: "per month",
    desc: "Complete learning experience with personalized support",
    features: [
      "Access to all 500+ courses",
      "Advanced certifications",
      "Premium study materials",
      "24/7 priority support",
      "Mobile app access",
      "Progress tracking",
      "Study groups access",
      "Monthly webinars",
      "1-on-1 mentoring sessions",
      "Career counseling",
      "Job placement assistance"
    ],
    popular: false,
    color: "#059669"
  },
  {
    name: "ENTERPRISE PLAN",
    price: "199K",
    period: "per month",
    desc: "Corporate training solution for teams and organizations",
    features: [
      "All course access for team",
      "Custom learning paths",
      "Team progress analytics",
      "Dedicated account manager",
      "Custom content creation",
      "API integration",
      "White-label solutions",
      "On-site training options",
      "Compliance reporting",
      "Priority support"
    ],
    popular: false,
    color: "#dc2626"
  },
]
export const faq = [
  {
    title: "How do I enroll in online courses?",
    desc: "Enrolling is simple! Just choose your preferred plan, create an account, and you'll have immediate access to our course library. You can start learning right away with our user-friendly platform.",
  },
  {
    title: "What payment methods do you accept?",
    desc: "We accept all major credit cards, debit cards, and digital wallets including PayPal, Apple Pay, and Google Pay. We also offer flexible payment plans for longer subscriptions.",
  },
  {
    title: "Can I cancel my subscription anytime?",
    desc: "Yes, you can cancel your subscription at any time. There are no long-term contracts or cancellation fees. You'll continue to have access until the end of your current billing period.",
  },
  {
    title: "Do you offer refunds?",
    desc: "We offer a 30-day money-back guarantee. If you're not satisfied with your learning experience within the first 30 days, we'll provide a full refund, no questions asked.",
  },
  {
    title: "Are the certificates recognized by employers?",
    desc: "Absolutely! Our certificates are industry-recognized and accredited. Many of our graduates have successfully used these certifications to advance their careers and secure new job opportunities.",
  },
  {
    title: "What kind of support do you provide?",
    desc: "We offer comprehensive support including 24/7 technical assistance, academic guidance, career counseling (Premium plans), and access to our community forums where you can connect with other learners.",
  },
  {
    title: "Can I access courses on mobile devices?",
    desc: "Yes! Our platform is fully responsive and works on all devices including smartphones, tablets, and desktop computers. You can download our mobile app for offline learning capabilities.",
  },
  {
    title: "How often do you add new courses?",
    desc: "We regularly update our course library with new content, typically adding 20-30 new courses every month. Premium and Enterprise subscribers get early access to new courses and exclusive content.",
  },
]
export const blog = [
  {
    id: 0,
    type: "admin",
    date: "DEC. 12, 2025",
    com: "4 COMMENTS ",
    title: "Humanitarian Relief in Action",
    desc: "SDTI is proud to announce our humanitarian effort for those affected by the natural disaster! This donation is a testament to the dedication found in our quality learning environments and our belief in understanding the importance of quality education that extends beyond the classroom.Key takeaways Building strong community partnerships Fostering student leadership and development We are happy to DONATE and provide essential support to our community in need. A sincere thank you to the founder of SDTI Campus, Dr. Shan Bandara, our students, lecturers, and non-academic staff who helped this.",

    cover: getImageUrl("./images/sahana2025/sahana05.jpg"),
    category: "Humanitarian",
    readTime: "6 min read",
    additionalPhotos: [
      getImageUrl("./images/sahana2025/sahana01.jpg"),
      getImageUrl("./images/sahana2025/sahana02.jpg"),
      getImageUrl("./images/sahana2025/sahana03.jpg"),
      getImageUrl("./images/sahana2025/sahana04.jpg"),
      getImageUrl("./images/sahana2025/sahana05.jpg"),
      getImageUrl("./images/sahana2025/sahana06.jpg"),
      getImageUrl("./images/sahana2025/sahana07.jpg"),
      getImageUrl("./images/sahana2025/sahana08.jpg"),
      getImageUrl("./images/sahana2025/sahana09.jpg"),
      getImageUrl("./images/sahana2025/sahana10.jpg"),
      getImageUrl("./images/sahana2025/sahana11.jpg"),
    ]
  },
  {
    id: 1,
    type: "admin",
    date: "DEC. 17, 2025",
    com: "2 COMMENTS ",
    title: "Book and Stationery Donation - Doluwa, Gampola ",
    desc: "Providing books and stationery to students in the Doluwa area who were affected by the natural disasters that occurred in the past few days, with the support of the Divisional Secretary and Assistant Divisional Secretary.",
    cover: getImageUrl("./images/doluwa/doluwa1.jpg"),
    category: "Humanitarian",
    readTime: "2 min read",
    additionalPhotos: [
        getImageUrl("./images/doluwa/doluwa1.jpg"),  
      getImageUrl("./images/doluwa/doluwa2.jpg"),
      getImageUrl("./images/doluwa/doluwa3.jpg"),
      getImageUrl("./images/doluwa/doluwa4.jpg"),
      getImageUrl("./images/doluwa/doluwa5.jpg"),
      getImageUrl("./images/doluwa/doluwa6.jpg"),
      getImageUrl("./images/doluwa/doluwa7.jpg"),
      getImageUrl("./images/doluwa/doluwa8.jpg"),
      getImageUrl("./images/doluwa/doluwa9.jpg"),
      getImageUrl("./images/doluwa/doluwa10.jpg"),
      getImageUrl("./images/doluwa/doluwa11.jpg"),
      getImageUrl("./images/doluwa/doluwa12.jpg"),
      getImageUrl("./images/doluwa/doluwa13.jpg"),
      getImageUrl("./images/doluwa/doluwa14.jpg"),
      getImageUrl("./images/doluwa/doluwa15.jpg"),
      getImageUrl("./images/doluwa/doluwa16.jpg"),
      getImageUrl("./images/doluwa/doluwa17.jpg"),
      getImageUrl("./images/doluwa/doluwa18.jpg"),
      
    ]
  },

  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2024",
    com: "3 COMMENTS ",
    title: "Empowering Students Through Social Service Programs",
    desc: "Discover how our social service initiatives are making a real difference in communities across Sri Lanka. From healthcare awareness to environmental conservation, our students are actively contributing to positive change.",
    cover: getImageUrl("./images/සමාජ සත්කාර/20210623_104942.jpg"),
    category: "Social Service",
    readTime: "5 min read",
    additionalPhotos: [
      getImageUrl("./images/සමාජ සත්කාර/IMG_5401.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/IMG_5405.jpeg"),
      getImageUrl("./images/සමාජ සත්කාර/IMG_5423.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210623_104942.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210623_110533.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210623_123215.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210630_151723.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210630_1654144.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210701_160136.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210802_114544.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210623_110533.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210623_123215.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210630_151723.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210630_1654144.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210630_1654145.jpg")

    ]
  },
  {
    id: 2,
    type: "admin",
    date: "FEB. 25, 2024",
    com: "5 COMMENTS ",
    title: "Innovative Teaching Methods in Modern Education",
    desc: "Explore cutting-edge teaching methodologies that are revolutionizing how we approach education. Learn about project-based learning, technology integration, and student-centered approaches.",
    cover: getImageUrl("./images/Teaching Prog/IMG_3499.jpg"),
    category: "Education",
    readTime: "7 min read",
    additionalPhotos: [
      getImageUrl("./images/Teaching Prog/IMG_3480.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_3430.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_3317.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_3289.jpg")
    ]
  },
  // {
  //   id: 3,
  //   type: "user",
  //   date: "MAR. 15, 2024",
  //   com: "10 COMMENTS ",
  //   title: "Student Success Stories: From Classroom to Career",
  //   desc: "Meet our outstanding graduates who have successfully transitioned from our programs to rewarding careers. Their journeys inspire current students and demonstrate the value of quality education.",
  //   cover: "./images/testo/t1.webp",
  //   category: "Student Life",
  //   readTime: "6 min read",
  //   additionalPhotos: [
  //     "./images/testo/t2.webp",
  //     "./images/testo/t3.webp"
  //   ]
  // },
  {
    id: 4,
    type: "admin",
    date: "APR. 02, 2024",
    com: "3 COMMENTS ",
    title: "Community Outreach: Building Stronger Societies",
    desc: "Our commitment to community development goes beyond the classroom. See how our programs are fostering social responsibility and creating lasting partnerships with local communities.",
    cover: getImageUrl("./images/සමාජ සත්කාර/IMG_5401.jpg"),
    category: "Community",
    readTime: "4 min read",
    additionalPhotos: [
      getImageUrl("./images/සමාජ සත්කාර/20210701_153045.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210701_160136.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/IMG_5428.jpg")
    ]
  },
  {
    id: 5,
    type: "admin",
    date: "MAY. 14, 2024",
    com: "3 COMMENTS ",
    title: "Professional Development in Teaching",
    desc: "Continuous learning is essential for educators. Discover our professional development programs that help teachers stay current with educational trends and methodologies.",
    cover: getImageUrl("./images/Teaching Prog/IMG_3480.jpg"),
    category: "Professional Development",
    readTime: "8 min read",
    additionalPhotos: [
      getImageUrl("./images/Teaching Prog/IMG_2967.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_2988.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_2858.jpg")
    ]
  },
  // {
  //   id: 6,
  //   type: "user",
  //   date: "JUN. 18, 2024",
  //   com: "12 COMMENTS ",
  //   title: "Testimonials: What Our Students Say",
  //   desc: "Hear directly from our students about their learning experiences, challenges overcome, and achievements celebrated. Real stories from real people who transformed their lives through education.",
  //   cover: "./images/testo/t2.webp",
  //   category: "Testimonials",
  //   readTime: "5 min read",
  //   additionalPhotos: [
  //     "./images/testo/t1.webp",
  //     "./images/testo/t3.webp"
  //   ]
  // },
  {
    id: 7,
    type: "admin",
    date: "JUL. 22, 2024",
    com: "8 COMMENTS ",
    title: "Innovative Learning Spaces and Facilities",
    desc: "Take a virtual tour of our state-of-the-art learning facilities. From modern classrooms to specialized labs, discover how our infrastructure supports effective learning.",
    cover: getImageUrl("./images/Teaching Prog/IMG_3430.jpg"),
    category: "Campus Life",
    readTime: "6 min read",
    additionalPhotos: [
      getImageUrl("./images/Teaching Prog/IMG_3317.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_3289.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_2988.jpg")
    ]
  },
  // {
  //   id: 8,
  //   type: "admin",
  //   date: "AUG. 30, 2024",
  //   com: "15 COMMENTS ",
  //   title: "Building Leadership Skills Through Education",
  //   desc: "Leadership development is integral to our educational philosophy. Learn how our programs cultivate leadership qualities that prepare students for future challenges and opportunities.",
  //   cover: "./images/testo/t3.webp",
  //   category: "Leadership",
  //   readTime: "7 min read",
  //   additionalPhotos: [
  //     "./images/testo/t1.webp",
  //     "./images/testo/t2.webp"
  //   ]
  // },
  {
    id: 9,
    type: "admin",
    date: "SEP. 15, 2024",
    com: "6 COMMENTS ",
    title: "Healthcare Awareness Programs in Communities",
    desc: "Our healthcare initiatives reach far beyond campus boundaries. See how we're educating communities about preventive healthcare, nutrition, and wellness practices.",
    cover: getImageUrl("./images/සමාජ සත්කාර/20210630_151723.jpg"),
    category: "Healthcare",
    readTime: "5 min read",
    additionalPhotos: [
      getImageUrl("./images/සමාජ සත්කාර/20210630_1654144.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/IMG_5437.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/IMG_5428.jpg")
    ]
  },
  {
    id: 10,
    type: "user",
    date: "OCT. 22, 2024",
    com: "9 COMMENTS ",
    title: "Environmental Conservation Initiatives",
    desc: "Join us in our mission to protect the environment. Our students lead tree planting campaigns, waste management programs, and sustainability workshops across communities.",
    cover: getImageUrl("./images/සමාජ සත්කාර/20210802_114544.jpg"),
    category: "Environment",
    readTime: "4 min read",
    additionalPhotos: [
      getImageUrl("./images/සමාජ සත්කාර/20210623_123215.jpg"),
      getImageUrl("./images/සමාජ සත්කාර/20210623_110533.jpg")
    ]
  },
  {
    id: 11,
    type: "admin",
    date: "NOV. 08, 2024",
    com: "11 COMMENTS ",
    title: "Advanced Teaching Techniques Workshop",
    desc: "Our faculty development workshops introduce cutting-edge teaching methodologies. From flipped classrooms to gamification, discover innovative approaches that enhance student engagement.",
    cover: getImageUrl("./images/Teaching Prog/IMG_2967.jpg"),
    category: "Workshops",
    readTime: "6 min read",
    additionalPhotos: [
      getImageUrl("./images/Teaching Prog/IMG_2988.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_2858.jpg"),
      getImageUrl("./images/Teaching Prog/IMG_284.jpeg")
    ]
  },
  {
    id: 12,
    type: "admin",
    date: "DEC. 20, 2024",
    com: "7 COMMENTS ",
    title: "Student Leadership Development Program",
    desc: "Leadership isn't just about position—it's about influence and positive change. Our comprehensive program develops confident, ethical leaders who make a difference in their communities.",
    cover: getImageUrl("./images/Teaching Prog/IMG_275.jpeg"),
    category: "Leadership",
    readTime: "8 min read",
    additionalPhotos: [
      getImageUrl("./images/Teaching Prog/IMG_273.jpeg"),
      getImageUrl("./images/Teaching Prog/IMG_272.jpeg"),
      getImageUrl("./images/Teaching Prog/IMG_271.jpeg")
    ]
  },
  {
    id: 13,
    type: "admin",
    date: "MAY. 25, 2024",
    com: "25 COMMENTS ",
    title: "Graduation Day 2024: Celebrating Success and Achievement",
    desc: "Join us in celebrating the remarkable achievements of our graduating class of 2024. This special day marks the culmination of years of hard work, dedication, and academic excellence.",
    cover: getImageUrl("./images/Graduation Special/Canon_Canon EOS 80D_2025-05-25_113026622.jpg"),
    category: "Graduation",
    readTime: "8 min read",
    additionalPhotos: [
      getImageUrl("./images/Graduation Special/A013-mi.jpeg"),
      getImageUrl("./images/Graduation Special/A014-mi.jpeg"),
      getImageUrl("./images/Graduation Special/503502410_1280207290771647_3161871300358913152_n.jpg"),
      getImageUrl("./images/Graduation Special/503452143_1280207360771640_7200856564798229561_n.jpg"),
      getImageUrl("./images/Graduation Special/503256751_1280207294104980_7519805074954606307_n.jpg")
    ]
  },
  {
    id: 14,
    type: "admin",
    date: "MAY. 25, 2024",
    com: "18 COMMENTS ",
    title: "Graduation Ceremony Highlights: Moments of Pride and Joy",
    desc: "Relive the magical moments from our graduation ceremony where dreams became reality. From the procession to the cap toss, every moment was filled with pride, joy, and celebration.",
    cover: getImageUrl("./images/Graduation Special/503231544_1280207150771661_4932145788881960538_n.jpg"),
    category: "Graduation",
    readTime: "6 min read",
    additionalPhotos: [
      getImageUrl("./images/Graduation Special/502412961_1278046177654425_2673860234346081135_n.jpg"),
      getImageUrl("./images/Graduation Special/502410178_1278046477654395_7663003498589035664_n.jpg"),
      getImageUrl("./images/Graduation Special/501491371_1278045884321121_5884436298341591632_n.jpg"),
      getImageUrl("./images/Graduation Special/473622863_1161970792595298_1164544084867917378_n.jpg")
    ]
  },
  // {
  //   id: 15,
  //   type: "user",
  //   date: "MAY. 25, 2024",
  //   com: "22 COMMENTS ",
  //   title: "Graduate Stories: From Student to Professional",
  //   desc: "Meet our exceptional graduates who have transformed their lives through education. Their inspiring stories showcase the power of determination, hard work, and quality education.",
  //   cover: "./images/Graduation Special/473620187_1161969932595384_8195860307286033297_n.jpg",
  //   category: "Graduation",
  //   readTime: "7 min read",
  //   additionalPhotos: [
  //     "./images/Graduation Special/473617643_1161424429316601_8788106027897909845_n.jpg",
  //     "./images/Graduation Special/473616697_1161969489262095_5066755821072208523_n.jpg",
  //     "./images/Graduation Special/473600469_1161971069261937_975482767043814565_n.jpg",
  //     "./images/Graduation Special/473591972_1161969565928754_360249085215840949_n.jpg"
  //   ]
  // },
  // {
  //   id: 16,
  //   type: "admin",
  //   date: "MAY. 25, 2024",
  //   com: "16 COMMENTS ",
  //   title: "Graduation Memories: Capturing the Spirit of Achievement",
  //   desc: "A visual journey through our graduation celebration, capturing the spirit of achievement, the joy of success, and the pride of accomplishment that defines this special day.",
  //   cover: "./images/Graduation Special/473591600_1161969159262128_6843669196530532825_n.jpg",
  //   category: "Graduation",
  //   readTime: "5 min read",
  //   additionalPhotos: [
  //     "./images/Graduation Special/473591041_1161969269262117_7091469417362200346_n.jpg",
  //     "./images/Graduation Special/473590248_1161969999262044_7919361765004469801_n.jpg",
  //     "./images/Graduation Special/473589153_1161969312595446_1367132858923677744_n.jpg",
  //     "./images/Graduation Special/473586403_1161969972595380_3143923620664648087_n.jpg",
  //     "./images/Graduation Special/473576898_1161969612595416_1303676268995549737_n.jpg"
  //   ]
  // },
  {
    id: 17,
    type: "admin",
    date: "MAY. 25, 2024",
    com: "14 COMMENTS ",
    title: "Graduation Traditions: Honoring Academic Excellence",
    desc: "Discover the rich traditions and ceremonies that make our graduation day truly special. From academic regalia to honorary recognitions, every element celebrates excellence.",
    cover: getImageUrl("./images/Graduation Special/473374909_1161969249262119_1357082775028391522_n.jpg"),
    category: "Graduation",
    readTime: "6 min read",
    additionalPhotos: [
      getImageUrl("./images/Graduation Special/453970139_542489831862721_2397143940728949399_n.jpg"),
      getImageUrl("./images/Graduation Special/379923268_251494751199518_8158933241376544005_n-mi.jpeg")
    ]
  }
]
export const testimonal = [
  {
    id: 1,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: getImageUrl("./images/testo/t1.webp"),
  },
  {
    id: 2,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: getImageUrl("./images/testo/t2.webp"),
  },
  {
    id: 3,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: getImageUrl("./images/testo/t3.webp"),
  },
]

export const locationPhotos = [
  {
    id: 1,
    name: "Ampara Campus",
    image: getImageUrl("./images/StdiLocation/Ampara.jpg"),
    description: "Our modern Ampara campus offers state-of-the-art facilities"
  },
  {
    id: 2,
    name: "Anuradhapura Campus",
    image: getImageUrl("./images/StdiLocation/Anuradhapura.jpg"),
    description: "Historic Anuradhapura location with excellent learning environment"
  },
  {
    id: 3,
    name: "Bandarawela Campus",
    image: getImageUrl("./images/StdiLocation/Bandarawela.jpg"),
    description: "Scenic Bandarawela campus in the hill country"
  },
  {
    id: 4,
    name: "Chilaw Campus",
    image: getImageUrl("./images/StdiLocation/chilaw.jpg"),
    description: "Coastal Chilaw campus with modern amenities"
  },
  {
    id: 5,
    name: "Galle Campus",
    image: getImageUrl("./images/StdiLocation/Galle.jpg"),
    description: "Historic Galle campus near the famous fort"
  },
  {
    id: 6,
    name: "Hambantota Campus",
    image: getImageUrl("./images/StdiLocation/Hambanthota.jpg"),
    description: "Southern province campus with excellent facilities"
  },
  {
    id: 7,
    name: "Island Wide Coverage",
    image: getImageUrl("./images/StdiLocation/Island wide.jpg"),
    description: "Our network spans across the entire island"
  },
  {
    id: 8,
    name: "Jaffna Campus",
    image: getImageUrl("./images/StdiLocation/Jaffna.jpg"),
    description: "Northern province campus serving the Tamil community"
  },
  {
    id: 9,
    name: "Kalutara Campus",
    image: getImageUrl("./images/StdiLocation/Kaluthara.jpg"),
    description: "Coastal Kalutara campus with modern infrastructure"
  },
  {
    id: 10,
    name: "Kandy Campus",
    image: getImageUrl("./images/StdiLocation/Kandy.jpg"),
    description: "Cultural capital campus in the heart of Kandy"
  },
  {
    id: 11,
    name: "Kegalle Campus",
    image: getImageUrl("./images/StdiLocation/Kegalle.jpg"),
    description: "Central province campus with excellent connectivity"
  },
  {
    id: 12,
    name: "Kiribathgoda Campus",
    image: getImageUrl("./images/StdiLocation/Kiribathgoda.jpg"),
    description: "Suburban campus close to Colombo"
  },
  {
    id: 13,
    name: "Kurunegala Campus",
    image: getImageUrl("./images/StdiLocation/Kurunegala.jpg"),
    description: "North Western province campus"
  },
  {
    id: 14,
    name: "Mahiyanganaya Campus",
    image: getImageUrl("./images/StdiLocation/mahaiyangana.jpg"),
    description: "Rural campus serving the Uva province"
  },
  {
    id: 15,
    name: "Matale Campus",
    image: getImageUrl("./images/StdiLocation/Matale.jpg"),
    description: "Central hills campus with beautiful surroundings"
  },
  {
    id: 16,
    name: "Matara Campus",
    image: getImageUrl("./images/StdiLocation/matara.jpg"),
    description: "Southern coastal campus"
  },
  {
    id: 17,
    name: "Monaragala Campus",
    image: getImageUrl("./images/StdiLocation/Monaragala.jpg"),
    description: "Uva province campus serving rural communities"
  },
  {
    id: 18,
    name: "Nugegoda Campus",
    image: getImageUrl("./images/StdiLocation/Nugegoda.jpg"),
    description: "Main suburban campus near Colombo"
  },
  {
    id: 19,
    name: "Polonnaruwa Campus",
    image: getImageUrl("./images/StdiLocation/Polonnaruwa.jpg"),
    description: "Ancient city campus with modern facilities"
  },
  {
    id: 20,
    name: "Ratnapura Campus",
    image: getImageUrl("./images/StdiLocation/Rathnapura.jpg"),
    description: "Gem city campus in Sabaragamuwa province"
  }
]

// Academic programmes list for the Courses page
export const programmes = [
  {
    title: "PhD Programmes",
    items: [
      "Management",
      "Education",
      "Hospitality and Tourism Management",
      "Law",
      "Information Technology",
      "Psychology",
    ],
  },
  {
    title: "Master Programmes",
    groups: [
      {
        name: "Master of Business Administration (MBA)",
        items: [
          "Business Strategy",
          "Human Resource Management",
          "Marketing Management",
          "Organizational Behavior",
          "Financial Management",
          "Strategic Information Management",
        ],
      },
      {
        name: "Master of Commerce (MCom)",
        items: [
          "Human resource management",
          "Banking and finance",
          "Management of information systems",
          "Tourism",
          "International business",
          "Business communication",
          "Accounting",
          "Marketing",
          "Public relations",
          "Micro- or macroeconomics",
        ],
      },
      {
        name: "Master of Science in Information Technology (MSc)",
        items: [
          "Methods for Developing Information Systems",
          "Statistical Data Analysis",
          "Development Technology",
          "Information Management",
          "Information Systems and Technology Strategy Formulation",
          "Database Systems",
          "Project Management Systems",
        ],
      },
    ],
  }
]

// Faculties and their offered programmes
export const faculties = [
  {
    name: "SCHOOL OF MANAGEMENT & FINANCE",
    programmes: [
      "Diploma in Human Resources Management",
      "Diploma in Banking & Finance",
      "Diploma in Business Management",
      "Diploma in Management",
      "B.Com Accounting",
      "B.Com Marketing",
      "B.Com Administrative Management",
      "B.Com Business Administration",
      "B.Com Human Resources Management",
      "BBM Business Management",
      "Bachelor of Economics (B. Ec ) Banking & Finance",
      "MBA Master of Business Administration",
    ],
  },
  {
    name: "SCHOOL OF COMPUTING",
    programmes: [
      "Diploma of IT (Cyber Security)",
      "Diploma in Computer",
      "Diploma in Software Engineering",
      "Diploma in Graphic Design",
      "Diploma in Video Editing",
      "Bachelor of Science (BSc) in Information Technology",
      "Bachelor of Science (BSc) in Computer Science",
      "Bachelor of Science (BSc) in Software Engineering",
      "MSc in Information Technology",
    ],
  },
  {
    name: "SCHOOL OF HEALTH CARE",
    programmes: [
      "MLT-Medical Laboratory Technician",
      "Certificate in Nursing",
      "Certificate in Pharmacy",
      "Certificate in Caregiver",
      "Diploma in Nursing",
    ],
  },
  {
    name: "SCHOOL OF EDUCATION",
    programmes: [
      "Diploma in English Teaching",
      "Diploma in Primary Teaching",
      "Diploma in Preschool Teaching",
      "Diploma in Tamil Teaching",
      "Diploma in Tamil Language",
      "Diploma in Spoken English",
      "Diploma in Japanese language",
      "Diploma in Psychology & Counselling",
      "Bachelor of Education in Teaching English as a Foreign Language",
      "B.Ed Bachelor of Education",
      "B.Sc in Psychology and Counselling",
      "M.Ed Master of Education",
    ],
  },
  {
    name: "SCHOOL OF FINE ART & DESIGN",
    programmes: [
      "Advanced Diploma in Fashion Design",
      "Diploma in Hair Dressing & Beauty Culture",
      "Diploma in Television and Film Production",
      "Bachelor of Fashion Design",
      "Bachelor of Performing Arts",
    ],
  },
  {
    name: "SCHOOL OF ENGINEERING",
    programmes: [
      "Diploma in Civil Engineering",
      "Diploma in Drafting Engineering",
      "Bsc Civil Engineering",
    ],
  },
  {
    name: "SCHOOL OF TOURISM",
    programmes: [
      "Diploma in Hotel & Tourism Management",
      "Diploma in Tourism & Tourist facilitator",
      "Certificate Course in Barista",
      "Bachelor of Commerce (B. Com) Tourism Management",
    ],
  },
]



